import gql from 'graphql-tag';

export const RE_DATE_DEAL_EVENT_ACTIVITIES = gql`
  mutation reDateDealEventActivities($input: ReDateDealEventActivitiesInput!) {
    dealActivity {
      result: reDateDealEventActivities(input: $input) {
        error
        success
        list {
          id
        }
      }
    }
  }
`;
